import useMediaQuery from './useMediaQuery'

/** @constant {string} Mobile breakpoint - screens 767px wide or less */
const MOBILE_BREAKPOINT = '(max-width: 767px)'

/**
 * A React hook that detects if the current viewport is mobile-sized.
 *
 * Mobile is defined as screens with a max-width of 767px.
 * The hook reactively updates when the viewport is resized across the breakpoint.
 *
 * @returns {boolean} True if the viewport width is 767px or less
 *
 * @example
 * const isMobile = useIsMobile()
 * if (isMobile) {
 *   // Render mobile-specific UI
 * }
 */
function useIsMobile() {
  return useMediaQuery(MOBILE_BREAKPOINT)
}

export default useIsMobile
